// What the stage alone does not say, as facts beside it in the deal's fields (TX-US-0043), the way
// a counterparty's StatusNotes sit beside its status. The facts are flow.js flowNotes', each with
// what follows from it, when anything does, set apart beneath.

import { Fragment } from 'react';

import { flowNotes } from './flow.js';

export default function FlowNotes({ deal, events }) {
  return flowNotes(deal, events).map((note) => (
    <Fragment key={note.label}>
      <dt>{note.label}</dt>
      <dd>
        {note.text}
        {note.hint && <small className="muted"> — {note.hint}</small>}
      </dd>
    </Fragment>
  ));
}
